import React from 'react';

export type CommentsConfig = { videosEnabled?: boolean; newsEnabled?: boolean };
export const DefaultCommentsConfig = {};
export const CommentsContext = React.createContext<CommentsConfig>(DefaultCommentsConfig);
export const useCommentsConfig = () => React.useContext<CommentsConfig>(CommentsContext);
